import { useHistory } from 'react-router-dom'
import DropdownMenu from 'components/misc/DropdownMenu'
import { useDispatch, useSelector } from 'react-redux'
import { MODAL_FROM_CONTEXTS, toggleModal } from '../../store/ui/actions'
import { setNotification } from 'store/notifications/actions'
import { userIsAtLeast } from 'lib/user'
import { setSelectedPapers } from 'store/add-report-dashboard-modal/actions'
import fullTextLink from 'lib/fulltext-link'

import styles from './styles/ReportDropdown.css'
import { PLANS } from '../../../server/lib/constants'
import { setMode } from '../../store/login-modal/actions'

const ReportDropdown = ({
  paper,
  claimPaper,
  isReferenceCheck = false
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const user = useSelector(({ ui }) => ui.user)

  const handleExport = () => {
    // if a user is an expert or does not have a free plan allow export.
    if (user && (user.expert || userIsAtLeast(user, PLANS.premium))) {
      dispatch(toggleModal('exportReport'))
      return
    }
    dispatch(toggleModal(user ? 'upgrade' : 'login', true, MODAL_FROM_CONTEXTS.REPORT_DOWNLOAD))
  }

  const handleClaimPaper = () => {
    if (user) {
      dispatch(claimPaper(user, paper))
      return
    }
    dispatch(setMode('register'))
    dispatch(toggleModal('login', true, MODAL_FROM_CONTEXTS.CLAIM_PAPER))
  }

  const handleSetAlert = () => {
    if (user) {
      dispatch(setNotification(
        {
          source: paper?.doi,
          name: paper?.title || 'untitled',
          category: 'paper',
          email: user?.email
        }))
      return
    }
    dispatch(setMode('register'))
    dispatch(toggleModal('login', true, MODAL_FROM_CONTEXTS.NOTIFICATION))
  }
  const items = [
    {
      iconEl: <img alt='See full text' src={`${CONFIG.assetsBaseURL}/images/icons/reports/full-text.svg`} />,
      label: 'See full text',
      handleClick: () => window.location = fullTextLink(paper) // eslint-disable-line
    },
    {
      iconEl: <img alt='Claim publication' src={`${CONFIG.assetsBaseURL}/images/icons/reports/claim-paper.svg`} />,
      label: 'Claim publication',
      handleClick: handleClaimPaper
    },
    {
      iconEl: <img alt='Set alert' src={`${CONFIG.assetsBaseURL}/images/icons/reports/set-alert.svg`} />,
      label: 'Set alert',
      handleClick: handleSetAlert
    },
    {
      iconEl: <img alt='Search for similar publications' src={`${CONFIG.assetsBaseURL}/images/icons/reports/search-papers.svg`} />,
      label: 'Search for similar publications',
      handleClick: () => history.push(`/search?q=${encodeURIComponent(paper?.title)}`)
    },
    {
      iconEl: <img alt='Visualize citation network' src={`${CONFIG.assetsBaseURL}/images/icons/reports/visualize-paper.svg`} />,
      label: 'Visualize citation network',
      handleClick: () => history.push(`/visualizations/${encodeURIComponent(paper?.doi)}`)
    },
    {
      iconEl: <img alt='Add to dashboard' src={`${CONFIG.assetsBaseURL}/images/icons/feature-dashboards.svg`} />,
      label: 'Add to dashboard',
      handleClick: () => {
        if (!paper) {
          return
        }
        if (!user?.email) {
          dispatch(setMode('register'))
          dispatch(toggleModal('login', true, MODAL_FROM_CONTEXTS.ADD_REPORT_DASHBOARD))
          return
        }

        dispatch(setSelectedPapers([paper]))
        dispatch(toggleModal('addReportToDashboard'))
      }
    },
    {
      iconEl: <img alt='Export report' src={`${CONFIG.assetsBaseURL}/images/icons/reports/download-csv.svg`} />,
      label: 'Export report',
      handleClick: handleExport
    }
  ]

  return <DropdownMenu containerClassName={styles.dropdownMenuContainer} items={items} />
}

export default ReportDropdown
